import { testDriveMember } from "../mockMembers";
import { mockPolicies } from "../mockPolicies";

import { MockPersona } from "./mockPersonas.types";

export const candaceCancelled: MockPersona = {
  key: "candaceCancelled",
  name: "Candace Cancelled",
  description: "🇨🇦 | One cancelled policy, no bills, no HDC",
  providerApiMockResponses: {
    cig: {
      billing: {
        fees: [],
        bills: [],
      },
      policies: {
        usa: [],
        canada: [mockPolicies["CC723641-01"]],
      },
    },
    esign: {
      fetchESignDocuments: [],
      createESignRequest: "error",
    },
    insurance: {
      fetchEndorsement: [],
    },
    soul: {
      fetchSoul: {
        hagertyAccounts: {
          myHagertyAccount: {
            id: "1",
            loginEmail: "candace@cancelled.com",
            firstName: "Candace",
            middleName: "",
            lastName: "Cancelled",
            mailingAddress: {
              line1: "1504 16 Ave SW",
              line2: "",
              city: "Calgary",
              state: "AB",
              postalCode: "T3C 0Z8",
              country: "CANADA",
            },
            preferredPhone: "4034527195",
            salesforceAccounts: [
              {
                accountNumber: "123",
                id: "1",
                partnerId: null,
              },
            ],
            drivetrainAccounts: [
              {
                customerAccountLegacyKey: "000006",
                source: "CANADA",
                customerSourceSystemKey: "123",
                id: "1",
                partnerCustomerId: "123",
                partnerId: "UNKNOWN",
              },
            ],
            identityAccounts: [],
            message: undefined,
          },
        },
      },
    },
    member: {
      fetchMember: {
        member: {
          member: testDriveMember,
        },
      },
    },
    billing: {
      fetchBilling: {
        bills: {
          bills: [],
          outstandingBalance: 0,
        },
      },
    },
    payments: {
      fetchPayEndorsementUrl: { payEndorsementUrl: "mock-url" },
    },
  },
};
